import React from "react";
import { useI18n } from "../lib/i18n";

const COLORS = {
  draft: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  sent: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  accepted: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  rejected: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  converted: "bg-violet-500/15 text-violet-300 border-violet-500/30",
  pending: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  paid: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  partial: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  overdue: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  cancelled: "bg-slate-500/15 text-slate-400 border-slate-500/30",
};

export default function StatusBadge({ status }) {
  const { t } = useI18n();
  const cls = COLORS[status] || "bg-slate-500/15 text-slate-300 border-slate-500/30";
  return (
    <span
      data-testid={`status-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${cls}`}
    >
      {t(`status.${status}`, status)}
    </span>
  );
}
